enum EventCreditType {
  Sponsored = 'Sponsored',
  External = 'External',
}
export default EventCreditType;
